export const SELECTION_TOOLBAR_LABEL = 'Selection toolbar';

export const DEFAULT_POPUP_SELECTORS = {
	toolbarContainer: '[role="toolbar"]',
	portal: '.atlaskit-portal',
} as const;
